<template lang="html">
  <root class="admin-user-view">

    <admin-nav></admin-nav>
    <page-header name="View User" :count='false'></page-header>

    <!-- Data -->
    <div class="container">
      <div class="row">
        <div class="col m6 offset-m3">
          <table class="striped">
            <tbody>
              <tr>
                <th>Phone</th>
                <td>+{{phone}}</td>
              </tr>
              <tr>
                <th>Country</th>
                <td>{{ country }}</td>
              </tr>
              <tr>
                <th>City</th>
                <td>{{ cityEn }}</td>
              </tr>
              <tr>
                <th>Business</th>
                <td>{{ business }}</td>
              </tr>
              <tr>
                <th>Orders</th>
                <td>{{ orders }}</td>
              </tr>
              <tr v-if="this.business != ''">
                <th>Sales</th>
                <td>{{ sales }}</td>
              </tr>
              <tr v-if="this.business != ''">
                <th>Earnings</th>
                <td>{{ _.round(earnings, 2) }}</td>
              </tr>
              <tr v-if="this.business != ''">
                <th>Fees</th>
                <td>{{ _.round(fees, 2) }}</td>
              </tr>
              <tr v-if="duePayments != undefined">
                <th>Due payments</th>
                <td>{{ _.round(duePayments, 2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="this.business != ''" class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" @click="update">Update due payments</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from "firebase";

export default {
  data() {
    return {
      phone: "",
      country: "",
      cityEn: "",
      duePayments: "",
      business: "",
      sales: "",
      earnings: "",
      fees: "",
      orders: "",
    };
  },
  methods: {
    collectUser() {
      let userKey = this.$route.params.userKey;
      firebase
        .database()
        .ref("users/" + userKey)
        .once("value")
        .then((userSnap) => {
          let userData = userSnap.val();
          this.phone = userData.phone;
          this.country = userData.country;
          this.duePayments = userData.due_payments;
          this.city = userData.city;

          //console.log("Due Payments " + this.duePayments);

          // Collect city
          firebase
            .database()
            .ref("countries/" + this.country + "/cities/" + this.city)
            .once("value")
            .then((citySnap) => {
              let citySnapVal = citySnap.val();

              if (citySnapVal != null) {
                this.cityEn = citySnapVal.name.en;
              }
            });

          // Collect business
          firebase
            .database()
            .ref("businesses")
            .orderByChild("user_key")
            .equalTo(userKey)
            .once("value")
            .then((businessesSnap) => {
              businessesSnap.forEach((businessSnap) => {
                this.business = businessSnap.val().name.en;
              });
            });

          //Collect sales reports
          firebase
            .database()
            .ref("sales_reports")
            .orderByChild("user_key")
            .equalTo(userKey)
            .once("value")
            .then((salesSnap) => {
              let sales = [];
              this.orders = salesSnap.numChildren();

              salesSnap.forEach((saleSnap) => {
                sales.push(saleSnap.val());
              });
              this.sales = _.sumBy(sales, "sale");
              this.earnings = _.sumBy(sales, "earning");
              this.fees = _.sumBy(sales, "fee");
            });
        });
    },
    update() {
      this.$router.push({ name: "UpdateDuePayment" });
    },
  },
  mounted() {
    this.collectUser();
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Admin/UserView.vue